<template>

  <splash>
    <template v-slot:splash-content>
      <v-icon>error</v-icon><span class="pl-2 pr-2">{{`Page ${$route.path} doesnt exist`}}</span><v-icon>error</v-icon>
    </template>
  </splash>

</template>
<script>
import Splash from '@/components/Splash'
export default {
  components: {
    splash: Splash
  }
}
</script>
